export default "assets/wine-shadow-49d8cc50.svg";